module.exports = { "default": require("core-js/library/fn/set-immediate"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/babel-runtime/core-js/set-immediate.js
// module id = ../../../node_modules/babel-runtime/core-js/set-immediate.js
// module chunks = 0